import { defineStore } from 'pinia'
import * as GameApi from '@/api/game'

export const useActivityStore = defineStore('activity', {
  state: () => ({
    financialData: null as any,
    isLoading: false,
    lastFetchTime: 0,
    // 缓存时间：30秒
    cacheTime: 30000
  }),

  getters: {
    // 检查是否有Eventos红点
    hasEventosBadge: (state) => {
      return state.financialData?.raffleCount > 0
    },

    // 获取转盘次数
    turntableCount: (state) => {
      return state.financialData?.raffleCount || 0
    },

    // 获取提现金额
    withdrawAmount: (state) => {
      return state.financialData?.withdrawAmount || 100
    },

    // 获取当前进度
    haveAmount: (state) => {
      return state.financialData?.haveAmount || 0
    },

    // 获取还需要多少金额
    remainingAmount: (state) => {
      const withdraw = state.financialData?.withdrawAmount || 100
      const have = state.financialData?.haveAmount || 0
      return Math.max(0, withdraw - have)
    },

    // 获取提现状态
    withdrawStatus: (state) => {
      return state.financialData?.withdrawStatus || false
    },

    // 获取倒计时时间
    countDownTime: (state) => {
      return state.financialData?.countDownTime || 0
    },

    // 获取提现记录列表
    withdrawAmountList: (state) => {
      return state.financialData?.withdrawAmountList || []
    },

    // 获取奖品信息
    rewardInfo: (state) => {
      return state.financialData?.rewardInfo || []
    }
  },

  actions: {
    // 获取基础数据（用于红点和转盘次数）
    async getBasicFinancialData() {
      // 检查缓存是否有效
      if (this.financialData && Date.now() - this.lastFetchTime < this.cacheTime) {
        return this.financialData
      }

      // 如果正在加载，返回现有数据
      if (this.isLoading) {
        return this.financialData
      }

      this.isLoading = true
      try {
        const res = await GameApi.financialInformation()
        this.financialData = res.data
        this.lastFetchTime = Date.now()
        return res.data
      } catch (error) {
        console.error('获取financialInformation数据失败:', error)
        throw error
      } finally {
        this.isLoading = false
      }
    },

    // 获取完整数据（用于转盘页面）
    async getFullFinancialData() {
      return await this.getBasicFinancialData()
    },

    // 强制刷新数据（清除缓存）
    async refreshFinancialData() {
      this.financialData = null
      this.lastFetchTime = 0
      return await this.getBasicFinancialData()
    },

    // 清除数据
    clearFinancialData() {
      this.financialData = null
      this.lastFetchTime = 0
      this.isLoading = false
    },

    // 更新转盘次数（用于转盘抽奖后）
    updateTurntableCount(newCount: number) {
      if (this.financialData) {
        this.financialData.raffleCount = newCount
      }
    },

    // 更新当前进度（用于转盘抽奖后）
    updateHaveAmount(newAmount: number) {
      if (this.financialData) {
        this.financialData.haveAmount = newAmount
      }
    }
  }
})